require('./watchClipsController');
require('../../shared/userPhoto/userPhotoDirective');
require('../../shared/infiniteCarousel/infiniteCarouselDirective');
require('../../player/jwPlayer/jwPlayerDirective');

"use strict";

angular.module('app.myHockeyTv.watchClips', [
  'app.myHockeyTv.watchClips.watchClipsController',
  'app.shared.infiniteCarousel.infiniteCarouselDirective'
])
    .config([
      '$stateProvider',
      function ($stateProvider) {
        $stateProvider.state('app.myHockeyTv.watchClips', {
          url: '/watch_clips',
          templateUrl: 'components/myHockeyTv/watchClips/watchClipsView.html',
          controller: 'app.myHockeyTv.watchClips.watchClipsController',
          controllerAs: 'watchClipsController',
          subTitle: 'Watch Clips',
          isChildState: true
        });
      }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/watchClips/watchClips.js